module.exports = __webpack_public_path__ + "img/sunqian.d1e551ce.png";